import React from "react";
import { useSelector } from "react-redux";
import { selectEntitiesByFilters } from "../../../../store/views/entityView";
import { usefulToolsDashboardFilters } from "../../../../utils/entitiesFiltersUtils";
import { usePermission } from "../../../../hooks/usePermission";
import Widget from "../../../features/widget/Widget";
import UsefulTool from "../../../features/usefulTool/UsefulTool";
import iconsList from "../../../ui/icons/iconsList";
import pathRouts from "../../../../enums/pathRoute";
import noToolsImg from "../../../../../assests/emptyList/tool.png";
import classes from "./UsefulToolsWidget.module.css";

const MAX_TOOLS_TO_SHOW = 6;

const UsefulToolsWidget = ({ domain, mainLink = `/${pathRouts.USEFULTOOLS}`, filter }) => {

    const { texts, lang } = useSelector(state => state.translate);
    const allTools = useSelector((state) => selectEntitiesByFilters(state, filter ? filter : usefulToolsDashboardFilters));
    const hasPermission = usePermission();
    const visibleTools = allTools?.filter(tool => hasPermission(tool.visibleTo))?.slice(0, MAX_TOOLS_TO_SHOW) || [];

    return (
        <Widget
            color="#4A4A4A"
            title={texts.usefulTools}
            titleColor="white"
            icon={iconsList.usefulTools}
            mainLink={`/${pathRouts.USEFULTOOLS}`}
            className={classes.UsefulToolsWidget}
            contentScrollable={false}
        >
            <div className={classes.ToolsList}>
                {visibleTools.length > 0 ?
                    visibleTools.map((tool,index) =>
                            <UsefulTool key={index} tool={{ ...tool, name: tool.name?.[lang] ?? tool.name }} />
                        )
                    :
                    <div className={classes.NoTools}>
                        {texts.noUsefulTools}
                        <img src={noToolsImg} alt={texts.noUsefulTools} className={classes.EmptyImage} />
                    </div>
                }
            </div>
        </Widget>
    );
};

export default UsefulToolsWidget; 